import { useTranslation } from "react-i18next";
import { isNativeMobile } from "../../../../utils/ionic";
import BackButton from "../../../../core/back";
import useStyles from "./styles";
import Divider from "../../../../core/divider";

interface Props {
  serial: string;
  siteName: string;
}

const MeteringPointDetails = ({ serial, siteName }: Props) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div>
      {!isNativeMobile() && (
        <>
          <BackButton defaultRoute={"/"} />
          <Divider />
          <h2>{t("Metering_Point")}</h2>
        </>
      )}
      <div
        className={classes.detailsRow}
        data-testid="metering-point-serial-item"
      >
        <div className={classes.label}>{t("Serial")}</div>
        <div className={classes.value}>{serial}</div>
      </div>

      <div
        className={classes.detailsRow}
        data-testid="metering-point-site-item"
      >
        <div className={classes.label}>{t("Site")}</div>
        <div className={classes.value}>{siteName}</div>
      </div>
      <Divider />
    </div>
  );
};

export default MeteringPointDetails;
